export const CLUSTER_CLASSIFY_FILL_COLOR_ATTRIBUTE = "count";
